/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService
 */

export const PlaylistLessonProgressResponseTypename = 'com.hubspot.learning.center.user.progress.core.playlist.PlaylistLessonProgressResponse';
export const PlaylistShortProgressResponseTypename = 'com.hubspot.learning.center.user.progress.core.playlist.PlaylistShortProgressResponse';
export const PlaylistTrackProgressResponseTypename = 'com.hubspot.learning.center.user.progress.core.playlist.PlaylistTrackProgressResponse';
export const getPlaylistProgressAggregationRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService',
  rpcName: 'getPlaylistProgressAggregation',
  auth: 'app',
  fingerprint: 'ZnJurUIRqAmv5P3JR22V-sQXt6vV-aDb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistProgressForUsersRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService',
  rpcName: 'getPlaylistProgressForUsers',
  auth: 'app',
  fingerprint: 'ik2eAnF0Kqq5MT7nNXGpNMQXt6vV-aDb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistProgressPaginatedRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService',
  rpcName: 'getPlaylistProgressPaginated',
  auth: 'app',
  fingerprint: '0EgGQ6X70b5KbKdhHA3aLsQXt6vV-aDb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};